/**
 * `previewNotImplemented.ts` — the one place a Spark Preview stub answers from.
 *
 * Some tools in the Answers-from-Docs and Answers-from-Memory specs describe
 * capabilities whose backend does not exist yet: no in-app document viewer to
 * highlight a passage in, and no query side on the conversation transcript.
 * They are registered anyway, against the registry's usual rule that only
 * working executors get a schema, because the alternative is worse: with no
 * tool at all the agent answers a memory question from the session it happens
 * to remember, and a "show me where it says that" from its own imagination.
 * A tool that refuses out loud is the honest shape of a feature that is coming.
 *
 * The result is a `tool_error:` so the base prompt's own rule applies — the
 * agent may not report the action as done — and it names the gap in words the
 * user can hear.
 *
 * **Grep this file to find everything still stubbed.** Each stub is replaced by
 * a real executor body in place; nothing here should outlive its feature.
 */

export function previewNotImplemented(feature: string, offerInstead?: string): string {
  return [
    `tool_error: not_implemented. ${feature} is not built yet in this preview.`,
    "Say plainly that this is not available yet. Do NOT describe it as done, and do NOT answer from memory or inference instead.",
    offerInstead ? `You may offer this instead: ${offerInstead}` : null,
  ]
    .filter(Boolean)
    .join(" ");
}
